(() => {
  'use strict';

  class ColdSugarProductPageCart {
    constructor(root) {
      this.root = root;

      this.localDock =
        root.querySelector(
          '[data-cs-local-cart-dock]'
        );

      this.shippingDock =
        root.querySelector(
          '[data-cs-shipping-box-dock]'
        );

      this.expandedAtY =
        window.scrollY;

      this.suppressProductFloatingWidgets();

      this.bind();

      void this.refresh();
    }

    suppressProductFloatingWidgets() {
      const hideWidgets = () => {
        /*
          Known Smile/rewards launchers.
        */
        const knownSelectors = [
          '#smile-ui-container',
          '#smile-ui-lite-container',
          '[id^="smile-ui"]',
          '[class*="smile-launcher"]',
          '[class*="smile_launcher"]',
          'iframe[title*="Rewards" i]',
          'iframe[title*="Smile" i]',
          'iframe[src*="smile.io" i]',
          'iframe[src*="smilecdn" i]',
          '[aria-label*="This Week" i]',
          '[aria-label*="Schedule" i]',
          '[title*="This Week" i]',
          '[title*="Schedule" i]',
          '[data-testid*="this-week" i]',
          '[class*="this-week" i]',
          '[id*="this-week" i]'
        ];

        document
          .querySelectorAll(
            knownSelectors.join(',')
          )
          .forEach(
            (element) => {
              let target =
                element;

              if (
                element.tagName ===
                  'IFRAME' &&
                element.parentElement
              ) {
                target =
                  element.parentElement;
              }

              target?.style
                ?.setProperty(
                  'display',
                  'none',
                  'important'
                );

              target?.style
                ?.setProperty(
                  'visibility',
                  'hidden',
                  'important'
                );

              target?.style
                ?.setProperty(
                  'pointer-events',
                  'none',
                  'important'
                );
            }
          );

        /*
          Fallback for third-party launchers whose generated
          class names change. Only hide a fixed/sticky ancestor
          when its visible launcher label is exactly one of the
          two product-page widgets we intentionally suppress.
        */
        document
          .querySelectorAll(
            'button, a, div, span'
          )
          .forEach(
            (element) => {
              const label =
                String(
                  element.textContent ||
                  ''
                )
                  .replace(
                    /\s+/g,
                    ' '
                  )
                  .trim();

              if (
                label !==
                  'Rewards' &&
                label !==
                  'This Week' &&
                label !== 'Schedule'
              ) {
                return;
              }

              let current =
                element;

              for (
                let depth = 0;
                depth < 7 &&
                current &&
                current !==
                  document.body;
                depth += 1
              ) {
                const style =
                  window.getComputedStyle(
                    current
                  );

                if (
                  style.position ===
                    'fixed' ||
                  style.position ===
                    'sticky'
                ) {
                  current.style
                    .setProperty(
                      'display',
                      'none',
                      'important'
                    );

                  current.style
                    .setProperty(
                      'visibility',
                      'hidden',
                      'important'
                    );

                  current.style
                    .setProperty(
                      'pointer-events',
                      'none',
                      'important'
                    );

                  break;
                }

                current =
                  current.parentElement;
              }
            }
          );
      };

      let queued =
        false;

      const scheduleHide =
        () => {
          if (queued) {
            return;
          }

          queued =
            true;

          window.requestAnimationFrame(
            () => {
              queued =
                false;

              hideWidgets();
            }
          );
        };

      hideWidgets();

      this.productWidgetObserver =
        new MutationObserver(
          scheduleHide
        );

      this.productWidgetObserver
        .observe(
          document.body,
          {
            childList: true,
            subtree: true
          }
        );
    }

    isSystemItem(item) {
      const properties =
        item?.properties ||
        {};

      return (
        properties
          ._cold_sugar_pickup_lock ===
          'true' ||
        properties
          ._cold_sugar_pickup_lock ===
          true ||
        properties
          ._cold_sugar_shipping_box_lock ===
          'true' ||
        properties
          ._cold_sugar_shipping_box_lock ===
          true ||
        item?.handle ===
          'pickup-location'
      );
    }

    visibleItems(cart) {
      return (
        cart?.items ||
        []
      ).filter(
        (item) =>
          !this.isSystemItem(
            item
          )
      );
    }

    visibleCount(cart) {
      return this.visibleItems(
        cart
      ).reduce(
        (total, item) =>
          total +
          Number(
            item.quantity ||
            0
          ),
        0
      );
    }

    determineMode(cart) {
      const modes =
        new Set();

      let unknown =
        false;

      this.visibleItems(
        cart
      ).forEach(
        (item) => {
          const mode =
            String(
              item?.properties
                ?._cold_sugar_order_mode ||
              ''
            )
              .trim()
              .toLowerCase();

          if (
            mode === 'local' ||
            mode === 'shipping'
          ) {
            modes.add(
              mode
            );
          } else {
            unknown =
              true;
          }
        }
      );

      if (
        modes.size === 0 &&
        !unknown
      ) {
        return 'empty';
      }

      if (
        modes.size > 1 ||
        unknown
      ) {
        return 'mixed';
      }

      return Array.from(
        modes
      )[0];
    }

    async fetchCart() {
      const response =
        await fetch(
          (
            window.routes
              ?.cart_url ||
            '/cart'
          ) +
            '.js',
          {
            headers: {
              Accept:
                'application/json',
              'X-Requested-With':
                'XMLHttpRequest'
            }
          }
        );

      if (!response.ok) {
        throw new Error(
          'Your cart could not be refreshed.'
        );
      }

      return response.json();
    }

    hideDock(dock) {
      if (!dock) {
        return;
      }

      dock.hidden =
        true;

      dock.classList.remove(
        'is-expanded',
        'is-collapsed'
      );
    }

    expandDock(dock) {
      if (
        !dock ||
        dock.hidden
      ) {
        return;
      }

      dock.classList.remove(
        'is-collapsed'
      );

      dock.classList.add(
        'is-expanded'
      );

      this.expandedAtY =
        window.scrollY;
    }

    renderLocal(
      cart,
      {
        expand = false
      } = {}
    ) {
      const count =
        this.visibleCount(
          cart
        );

      if (
        this.determineMode(
          cart
        ) !== 'local' ||
        count <= 0
      ) {
        this.hideDock(
          this.localDock
        );

        return;
      }

      const attributes =
        cart?.attributes ||
        {};

      const title =
        this.localDock
          ?.querySelector(
            '[data-cs-local-cart-dock-title]'
          );

      const copy =
        this.localDock
          ?.querySelector(
            '[data-cs-local-cart-dock-copy]'
          );

      const countNode =
        this.localDock
          ?.querySelector(
            '[data-cs-local-cart-dock-count]'
          );

      if (title) {
        title.textContent =
          `${count} ${
            count === 1
              ? 'item'
              : 'items'
          } in your cart`;
      }

      const location =
        String(
          attributes[
            'Fulfillment Option Name'
          ] ||
          attributes[
            'Pickup Location'
          ] ||
          ''
        ).trim();

      if (copy) {
        copy.textContent =
          location
            ? `Pickup: ${location}`
            : 'Local pickup';
      }

      if (countNode) {
        countNode.textContent =
          `· ${count}`;
      }

      this.localDock.hidden =
        false;

      if (
        expand ||
        (
          !this.localDock
            .classList.contains(
              'is-expanded'
            ) &&
          !this.localDock
            .classList.contains(
              'is-collapsed'
            )
        )
      ) {
        this.expandDock(
          this.localDock
        );
      }
    }

    async renderShipping(
      cart,
      {
        expand = false
      } = {}
    ) {
      const count =
        this.visibleCount(
          cart
        );

      if (
        this.determineMode(
          cart
        ) !== 'shipping' ||
        count <= 0
      ) {
        this.hideDock(
          this.shippingDock
        );

        return;
      }

      this.shippingDock.hidden =
        false;

      try {
        await Promise.resolve(
          window
            .ColdSugarShippingBoxUI
            ?.renderAll?.(
              cart
            )
        );
      } catch (error) {
        console.error(
          'Cold Sugar product shipping dock refresh failed:',
          error
        );
      }

      const engine =
        window
          .ColdSugarShippingBox;

      const result =
        engine
          ?.summarizeItems?.(
            cart.items ||
            []
          );

      const title =
        this.shippingDock
          ?.querySelector(
            '[data-cs-shipping-box-dock-title]'
          );

      const copy =
        this.shippingDock
          ?.querySelector(
            '[data-cs-shipping-box-dock-copy]'
          );

      const countNode =
        this.shippingDock
          ?.querySelector(
            '[data-cs-shipping-box-dock-count]'
          );

      if (
        title &&
        !String(
          title.textContent ||
          ''
        ).trim()
      ) {
        if (
          result?.valid &&
          result.tier ===
            'merch_only'
        ) {
          title.textContent =
            'Merch shipping';
        } else if (
          result?.valid &&
          result.box
        ) {
          title.textContent =
            `${result.box} Shipping Box`;
        } else {
          title.textContent =
            `${count} ${
              count === 1
                ? 'item'
                : 'items'
            } in your cart`;
        }
      }

      if (
        copy &&
        !String(
          copy.textContent ||
          ''
        ).trim()
      ) {
        copy.textContent =
          engine
            ?.formatContents?.(
              result?.counts ||
              {}
            ) ||
          'Nationwide shipping';
      }

      if (
        countNode &&
        !String(
          countNode.textContent ||
          ''
        ).trim()
      ) {
        countNode.textContent =
          `· ${count}`;
      }

      if (
        expand ||
        (
          !this.shippingDock
            .classList.contains(
              'is-expanded'
            ) &&
          !this.shippingDock
            .classList.contains(
              'is-collapsed'
            )
        )
      ) {
        this.expandDock(
          this.shippingDock
        );
      }
    }

    async refresh({
      cart = null,
      expand = false
    } = {}) {
      const state =
        cart ||
        await this.fetchCart();

      const mode =
        this.determineMode(
          state
        );

      if (mode !== 'local') {
        this.hideDock(
          this.localDock
        );
      }

      if (mode !== 'shipping') {
        this.hideDock(
          this.shippingDock
        );
      }

      this.renderLocal(
        state,
        {
          expand
        }
      );

      await this.renderShipping(
        state,
        {
          expand
        }
      );

      return state;
    }

    collapseActiveDock() {
      const dock =
        [
          this.localDock,
          this.shippingDock
        ].find(
          (candidate) =>
            candidate &&
            !candidate.hidden
        );

      if (
        !dock ||
        dock.classList.contains(
          'is-collapsed'
        )
      ) {
        return;
      }

      dock.classList.remove(
        'is-expanded'
      );

      dock.classList.add(
        'is-collapsed'
      );
    }

    bind() {
      let queued =
        false;

      window.addEventListener(
        'scroll',
        () => {
          if (queued) {
            return;
          }

          queued =
            true;

          window.requestAnimationFrame(
            () => {
              queued =
                false;

              if (
                Math.abs(
                  window.scrollY -
                  this.expandedAtY
                ) >= 48
              ) {
                this.collapseActiveDock();
              }
            }
          );
        },
        {
          passive: true
        }
      );

      document.addEventListener(
        'cart:updated',
        (event) => {
          void this.refresh({
            cart:
              event.detail
                ?.cart ||
              null,
            expand:
              Boolean(
                event.detail
                  ?.expandColdSugarDock
              )
          });
        }
      );
    }
  }

  const initialize = () => {
    const root =
      document.querySelector(
        '[data-cs-product-page-docks]'
      );

    if (
      !root ||
      window
        .ColdSugarProductPageCart
    ) {
      return;
    }

    window
      .ColdSugarProductPageCart =
      new ColdSugarProductPageCart(
        root
      );
  };

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      {
        once: true
      }
    );
  } else {
    initialize();
  }
})();
